// Deterministic placeholder thumbnail for a model (C0-R locked decision). There is
// no render pipeline yet — Model.thumbnail_ref exists in the schema but is unused;
// real render-on-save thumbnails (a headless stage capture) are a documented TODO.
// REFACTOR-NOTE(partial-implementation): render pipeline unbuilt; Model.thumbnail_ref exists in the schema but is unused (placeholder-only). See REFACTOR_ISSUES.md.
// Until then we derive a stable, on-brand gradient + initial from the model id so
// each model reads as visually distinct and consistent across sessions.

function hashStr(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export interface Thumb {
  gradient: string;
  initial: string;
}

export function modelThumbnail(model: { id: string; name: string }): Thumb {
  const h = hashStr(model.id || model.name);
  const hue1 = h % 360;
  const hue2 = (hue1 + 35 + (h % 50)) % 360;
  return {
    gradient: `linear-gradient(135deg, hsl(${hue1} 68% 56%), hsl(${hue2} 60% 40%))`,
    initial: (model.name.trim()[0] || 'U').toUpperCase(),
  };
}
